/** Shared entity-card constants and layout helpers — no tldraw imports (safe for list page). */

export const ENTITY_CARD_SHAPE_TYPE = 'entity-card';
export const ENTITY_CARD_WIDTH = 360;
export const ENTITY_CARD_HEIGHT = 0;
export const ENTITY_CARD_DRAG_MIME = 'application/x-report-notes-entity-card';
export const ENTITY_CARD_OPEN_DETAILS_EVENT = 'whiteboard:entity-card-open-details';
export const ENTITY_CARD_CONFIRM_REVIEW_EVENT = 'whiteboard:entity-card-confirm-review';
export const ENTITY_CARD_REJECT_REVIEW_EVENT = 'whiteboard:entity-card-reject-review';

export const MAX_PINNED_PROPERTIES = 3;
export const MAX_PINNED_ALIASES = 5;
export const CARVER_FACTOR_COUNT = 6;
/** Default per-factor max (matches useCarverConfig fallback). Card chip uses fixed /60. */
export const CARVER_MAX_SCORE_PER_FACTOR = 10;
export const CARVER_MAX_TOTAL = CARVER_FACTOR_COUNT * CARVER_MAX_SCORE_PER_FACTOR;

const CARD_VERTICAL_PADDING = 24;
const CARD_IMAGE_SIZE = 64;
export const ENTITY_CARD_MAX_HEIGHT = 300;
const DESCRIPTION_CHARS_PER_LINE = 48;
const DESCRIPTION_MAX_LINES = 3;
const TITLE_ROW_HEIGHT = 24;
const DESCRIPTION_LINE_HEIGHT = 20;
const AKA_LINE_HEIGHT = 20;
const TITLE_DESCRIPTION_GAP = 8;
const COUNTRIES_ROW_HEIGHT = 24;
const KB_LINK_ROW_HEIGHT = 22;
const PINNED_PROPERTY_ROW_HEIGHT = 18;
const PINNED_SECTION_GAP = 6;
const CARVER_CHIP_ROW_HEIGHT = 22;
const KB_UPDATED_ROW_HEIGHT = 18;

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function getDescriptionLinesCount(description) {
    if (!description) return 0;
    const approxLines = Math.ceil(String(description).trim().length / DESCRIPTION_CHARS_PER_LINE);
    return clamp(approxLines, 1, DESCRIPTION_MAX_LINES);
}

function getPinnedPropertiesCount(props) {
    if (!Array.isArray(props?.pinnedProperties)) return 0;
    return Math.min(props.pinnedProperties.length, MAX_PINNED_PROPERTIES);
}

function hasPinnedAliases(props) {
    if (!Array.isArray(props?.pinnedAliases)) return false;
    return props.pinnedAliases.some((alias) => typeof alias === 'string' && alias.trim());
}

export function computeEntityCardHeight(props) {
    const descriptionLines = getDescriptionLinesCount(props?.description);
    const hasCountries =
        (Array.isArray(props?.relatedCountryDetails) && props.relatedCountryDetails.length > 0) ||
        (Array.isArray(props?.relatedCountries) && props.relatedCountries.length > 0);
    const hasKbLink = Boolean(props?.kbUrl);
    const pinnedCount = getPinnedPropertiesCount(props);
    const showAka = hasPinnedAliases(props);
    const hasCarverChip = Boolean(props?.carverPinned);
    const hasKbUpdated = Boolean(props?.kbLastUpdatedPinned);

    const dynamicHeight =
        CARD_VERTICAL_PADDING +
        TITLE_ROW_HEIGHT +
        (showAka ? AKA_LINE_HEIGHT : 0) +
        (hasKbUpdated ? KB_UPDATED_ROW_HEIGHT : 0) +
        TITLE_DESCRIPTION_GAP +
        descriptionLines * DESCRIPTION_LINE_HEIGHT +
        (hasCountries ? COUNTRIES_ROW_HEIGHT : 0) +
        (hasKbLink ? KB_LINK_ROW_HEIGHT : 0) +
        (pinnedCount > 0 ? PINNED_SECTION_GAP + pinnedCount * PINNED_PROPERTY_ROW_HEIGHT : 0) +
        (hasCarverChip ? PINNED_SECTION_GAP + CARVER_CHIP_ROW_HEIGHT : 0);

    const minForImage = CARD_VERTICAL_PADDING + CARD_IMAGE_SIZE;
    return Math.min(Math.max(dynamicHeight, minForImage), ENTITY_CARD_MAX_HEIGHT);
}
